import {graphql} from '~/graphql-react-query';

// We don't actually read the id but it means the query response matches the generated type
export const ComplianceCodeList = graphql(`
    query ComplianceCodeList {
        compliance {
            codeList {
                items {
                    id
                    codeId
                    codeName
                    industries
                    country
                }
            }
        }
    }
`);

export const ComplianceCreativeListV2 = graphql(`
    query complianceCreativeListV2($input: ComplianceCreativeListV2QueryInput!) {
        compliance {
            creativeListV2(input: $input) {
                paginationInfo {
                    nextPageCursor
                    mightHaveNextPage
                    receivedCreatives
                }
                items {
                    progressStatus
                    id
                    creative
                    firstAppeared
                    lastAppeared
                    status

                    mediaTypeList {
                        id
                        name
                        canonicalName
                    }
                    mediaOwnerList {
                        id
                        name
                    }
                    publisherList {
                        id
                        name
                    }
                    publicationList {
                        id
                        name
                    }
                    regionList {
                        id
                        name
                    }
                    country
                    placementTypes
                    advertiserDomain
                    aiExtractedTextV1
                    aiTranscriptionTextV1
                    aiAdTypeV1
                    aiCampaignHeadlineV1
                    aiDemographicsV1 {
                        genderDistribution {
                            unspecified
                            female
                            male
                        }
                        ageBracket
                        ageName
                    }
                    aiSummaryInsightsV1 {
                        summary150
                        summary300
                    }
                    aiTagsV1 {
                        advertiser
                        industry
                        category
                        product
                        fuelType
                    }
                    compliance {
                        compliance_code
                        compliance_code_id
                        compliance_risk_rating
                        compliance_reason
                    }
                }
            }
        }
    }
`);

export const ComplianceCsv = graphql(`
    query ComplianceCsv($input: ComplianceCsvInput!) {
        compliance {
            csv(input: $input) {
                csv
                errorJson
            }
        }
    }
`);

export const ComplianceReviewCreativeQuery = graphql(`
    query ComplianceReviewCreative($complianceCodeId: String!, $creativeId: String!) {
        compliance {
            creative(input: {complianceCodeId: $complianceCodeId, creativeId: $creativeId}) {
                creativeId
                teamId
                complianceCodeId
                progressStatus
                notes
                shortlists
                history {
                    summary
                    actor
                    timestamp
                }
                createdAt
                createdBy
                updatedAt
                updatedBy
                creative {
                    id
                    creative
                    firstAppeared
                    lastAppeared
                    status
                    mediaTypeList {
                        id
                        name
                        canonicalName
                    }
                    mediaOwnerList {
                        id
                        name
                    }
                    publisherList {
                        id
                        name
                    }
                    publicationList {
                        id
                        name
                    }
                    regionList {
                        id
                        name
                    }
                    country
                    placementTypes
                    advertiserDomain
                    aiExtractedTextV1
                    aiTranscriptionTextV1
                    aiAdTypeV1
                    aiCampaignHeadlineV1
                    compliance {
                        compliance_code
                        compliance_code_id
                        compliance_risk_rating
                        compliance_reason
                    }
                }
            }
        }
    }
`);

export const ComplianceUpdateCreative = graphql(`
    mutation ComplianceUpdateCreative($input: ComplianceCreativeUpdateMutationInput!) {
        compliance {
            updateComplianceCreative(input: $input) {
                creativeId
                teamId
                complianceCodeId
                progressStatus
                notes
                shortlists
                history {
                    summary
                    actor
                    timestamp
                }
                createdAt
                createdBy
                updatedAt
                updatedBy
            }
        }
    }
`);
